module.exports = __webpack_public_path__ + "static/img/设计师4.7f9c636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师4.jpg
// module id = Us8m
// module chunks = 1